import { API_URL } from "./config";
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { KeyRound } from 'lucide-react';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import UnlockLink from './pages/UnlockLink';
import Pricing from './pages/Pricing';
import './App.css';

const TelegramAuthHandler = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const initTelegramAuth = async () => {
      
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) {
        const tg = window.Telegram.WebApp;

        try {
          const response = await axios.post(`${API_URL}/auth/telegram`, {
            initData: tg.initData,
            user: tg.initDataUnsafe?.user
          });
          login(response.data.token, response.data.user);
          navigate('/dashboard');
        } catch (err) {
            console.error(err);
            setError('Telegram Authentication Failed.');
        }
      } else if (user) {
         
         navigate('/dashboard');
      }
    };
    initTelegramAuth();
  }, [login, navigate, user]);

  useEffect(() => {
    if (!window.Telegram || !window.Telegram.WebApp || !window.Telegram.WebApp.initData) {
      if (!user && !error) {
        navigate('/login');
      }
    }
  }, [navigate, user, error]);

  if (error) {
     return <div className="min-h-screen flex flex-col items-center justify-center bg-black text-red-500 font-mono text-sm">{error}</div>;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black">
      <div className="flex items-center gap-3">
        <KeyRound className="w-10 h-10 -rotate-45 text-white drop-shadow-[0_0_8px_rgba(255,255,255,0.8)]" />
        <span className="text-3xl font-bold tracking-widest text-white font-mono">LINKEY</span>
      </div>
    </div>
  );
};

const SplashScreen = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-black">
    <div className="flex items-center gap-3">
      <KeyRound className="w-10 h-10 -rotate-45 text-white drop-shadow-[0_0_8px_rgba(255,255,255,0.8)]" />
      <span className="text-3xl font-bold tracking-widest text-white font-mono">LINKEY</span>
    </div>
  </div>
);

const RootRoute = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const initTelegramAuth = async () => {
      const tg = window.Telegram?.WebApp;
      if (tg && tg.initData) {
        try {
          const response = await axios.post(`${API_URL}/auth/telegram`, {
            initData: tg.initData,
            user: tg.initDataUnsafe?.user
          });
          login(response.data.token, response.data.user);
          navigate('/dashboard');
        } catch (err) {
            console.error('Telegram auth failed:', err);
            setError('Telegram Authentication Failed.');
        }
      } else if (user) {
         
         navigate('/dashboard');
      }
    };
    initTelegramAuth();
  }, [login, navigate, user]);

  const tg = window.Telegram?.WebApp;

  if (tg && tg.initData) {
     if (error) {
         return <div className="min-h-screen flex flex-col items-center justify-center bg-black text-red-500 font-mono text-sm">{error}</div>;
     }
     return <SplashScreen />;
  }
  
  if (error) {
     return <div className="min-h-screen flex flex-col items-center justify-center bg-black text-red-500 font-mono text-sm">{error}</div>;
  }

  if (user) {
     return <SplashScreen />;
  }

  return <LandingPage />;
};

function App() {
  return (
    <AuthProvider>
        <Router>
        <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="/telegram-auth" element={<TelegramAuthHandler />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/unlock/:id" element={<UnlockLink />} />
            <Route path="/pricing" element={<Pricing />} />
        </Routes>
        </Router>
    </AuthProvider>
  );
}

export default App;
